/**
 * Role Management Utilities
 *
 * สิทธิ์ผู้ใช้งาน MFU:
 *
 * [mfu-admin.dietz.asia]
 * - admin_doctor : หมอ Admin → สมุดสุขภาพ + Setup template
 *
 * [mfu-superadmin.dietz.asia]
 * - super_admin  : เข้าได้ทุกหน้า (กลุ่มผู้รับตรวจ, จัดการบริษัท, จัดการผู้ใช้,
 *                  สมุดสุขภาพ, Setup template, Dashboard องค์กร)
 * - manager      : กลุ่มผู้รับการตรวจสุขภาพ + จัดการบริษัท
 * - analyze      : Dashboard องค์กร
 * - nurse        : สมุดสุขภาพ
 */

export const ROLES = {
  ADMIN_DOCTOR: 'admin_doctor', // หมอ Admin → mfu-admin เท่านั้น
  SUPER_ADMIN: 'super_admin',   // เข้าได้ทุกหน้าใน mfu-superadmin
  MANAGER: 'manager',           // กลุ่มผู้รับการตรวจสุขภาพ + จัดการบริษัท
  ANALYZE: 'analyze',           // Dashboard องค์กร
  NURSE: 'nurse'                // สมุดสุขภาพ
};

export const PAGE_ACCESS = {
  '/user-management': [ROLES.SUPER_ADMIN],
  '/health-groups': [ROLES.SUPER_ADMIN, ROLES.MANAGER],
  '/campaigns': [ROLES.SUPER_ADMIN, ROLES.MANAGER],
  '/dashboard-organization': [ROLES.SUPER_ADMIN, ROLES.ANALYZE],
  '/healthbook': [ROLES.SUPER_ADMIN, ROLES.NURSE],
  '/health-records-history': [ROLES.SUPER_ADMIN, ROLES.NURSE],
  // admin_doctor ใช้ template ใน mfu-admin แทน
  '/template': [ROLES.SUPER_ADMIN],
  '/': [ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ANALYZE, ROLES.NURSE],
  '/login': [ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ANALYZE, ROLES.NURSE]
};

export const hasAnyRole = (userRoles, requiredRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }
  const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  return userRoles.some(role => required.includes(role));
};

export const hasAllRoles = (userRoles, requiredRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }
  const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  return required.every(role => userRoles.includes(role));
};

export const canAccessPage = (userRoles, path, userLevel = null) => {
  if (hasAnyRole(userRoles, [ROLES.SUPER_ADMIN])) {
    return true;
  }

  const allowedRoles = PAGE_ACCESS[path];

  if (!allowedRoles) {
    return false;
  }

  return hasAnyRole(userRoles, allowedRoles);
};

export const filterMenuByRole = (menuItems, userRoles, userLevel = null) => {
  if (!userRoles || !Array.isArray(userRoles)) {
    return [];
  }
  return menuItems.filter(item => {
    if (!item.path) return false;
    return canAccessPage(userRoles, item.path, userLevel);
  });
};

export const isSuperAdmin = (userRoles) => {
  return hasAnyRole(userRoles, ROLES.SUPER_ADMIN);
};

export const isManager = (userRoles) => {
  return hasAnyRole(userRoles, ROLES.MANAGER);
};

export const isAnalyze = (userRoles) => {
  return hasAnyRole(userRoles, ROLES.ANALYZE);
};

export const isNurse = (userRoles) => {
  return hasAnyRole(userRoles, ROLES.NURSE);
};

export const getDefaultPage = (userRoles, userLevel = null) => {
  if (!userRoles || !Array.isArray(userRoles) || userRoles.length === 0) {
    return '/login';
  }

  if (isSuperAdmin(userRoles)) {
    return '/health-groups';
  }

  if (isManager(userRoles)) {
    return '/health-groups';
  }

  if (isAnalyze(userRoles)) {
    return '/dashboard-organization';
  }

  if (isNurse(userRoles)) {
    return '/healthbook';
  }

  return '/login';
};
